//用户
import {profile} from "../../api/account";
export default {
  state: {
    user: {
      permission: {
        frontMenu: []
      },
    },
  },
  mutations: {
    GET_ACCOUNT_PROFILE(state, user) {
      state.user = user
    },
  },
  actions: {
    getAccountProfile({commit}) {
      return profile().then(res => {
        var data = res.data
        if (data.code == '000') {
          commit('GET_ACCOUNT_PROFILE', data.content)
        } else {
          commit('GET_ACCOUNT_PROFILE', {
            permission: {
              frontMenu: []
            },
          })
        }
      }).catch(err => {
        commit('GET_ACCOUNT_PROFILE', {
          permission: {
            frontMenu: []
          },
        })
        console.log(err);
      })
    },

  },
}
